import type { IntlShape } from 'react-intl';
import type { SubscriptionFeature } from '@alltrails/types/SubscriptionFeature';
import offlineMapsSrc from './images/offline-maps-thumb.avif';

// https://www.figma.com/design/vV97hwFyKhekbcMy2TuNyz/Feature-Merchandising?node-id=840-95326&t=XlR2wnwWYYfdIIZ3-4
const unlimitedMapDownloads = (intl: IntlShape): SubscriptionFeature => ({
  headline: intl.formatMessage({ defaultMessage: 'Unlimited Map Downloads' }),
  subheadline: intl.formatMessage({ defaultMessage: 'Download maps so you know where you are, even offline' }),
  thumbnailImage: offlineMapsSrc.src
});

export default unlimitedMapDownloads;
